import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import CustomerRouter from "@/routers/customer.js" //客户管理
import ProductRouter from "@/routers/product.js" //产品管理
import MachinePartsRouter from "@/routers/machineParts.js" //配件管理
import ProjectRouter from "@/routers/project.js" //项目管理
import OrderRouter from "@/routers/order.js" //售后工单管理
import WechatRouter from "@/routers/wechat.js" //微信公众号
import StaffRouter from "@/routers/staff.js" //员工管理
// import DailyRouter from "@/routers/daily.js" //工时日报 （未开发）
import workshopRouter from "@/routers/workshop.js" //车间工时管理
import EnterpriseRouter from "@/routers/enterprise.js" //企业产品
import sys from "@/routers/sys.js" //sys

import CcConstant from './components/cc-constant-admin' //活动模块字典

import login from './views/Login.vue'

import test from './views/test.vue'


import awaitDaily from "@/routers/awaitDaily.js" //待提交日报

import statistics from '@/routers/statistics';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'loginTest',
      component: login
    },
    {
      path: '/',
      // name: 'home',
      // component: Home
      name: 'index',
      component: r => require.ensure([], () => r(require('@/views/404')), 'index')
    },
    
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/workbench',
      name: 'Workbench',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/component/Workbench.vue')
    },
    {
      //语言转换
      path: '/admin/language',
      name: 'ChangeLanguage',
      component: r => require.ensure([], () => r(require('@/views/component/ChangeLanguage')), 'ChangeLanguage')
    },
    {
      //活动模块字典
      path: "/admin/dict",
      name: "ActivityDict",
      component: CcConstant.CcConstantAdmin,
      props: {
        //这是API的目录地址
        apiSrc: "admin/dict/"
      }
    },
    ...CustomerRouter,
    ...ProductRouter,
    ...MachinePartsRouter,
    ...ProjectRouter,
    ...OrderRouter,
    ...WechatRouter,
    ...StaffRouter,
    // ...DailyRouter,
    ...workshopRouter,
    ...EnterpriseRouter,
    ...sys,
    ...awaitDaily,
    ...statistics
  ]
})
